import React from "react";
import { useLocation, Link } from "react-router-dom";
import "../css/siderBar.scss";
import Cookies from "js-cookie";
import { useTranslation } from "../contexts/LocaleContext";

const SiderBar = ({ isCollapsed, mobileOpen, onMobileClose }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const { t } = useTranslation();

  // 定义导航项
  const navItems = [
    {
      path: "/Home/main",
      title: t ? t("sidebar.dashboard") : "Dashboard",
      icon: (
        <svg
          viewBox="0 0 24 24"
          width={24}
          height={24}
          stroke="currentColor"
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="_icon_fe04826"
        >
          <path d="M8 17h8M11.018 2.764 4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 0 0-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 0 0-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275c-.351-.273-.527-.41-.72-.462a1 1 0 0 0-.523 0c-.194.052-.37.189-.721.462Z" />
        </svg>
      ),
    },
    {
      path: "/Home/users",
      title: t ? t("sidebar.users") : "Users",
      icon: (
        <svg
          t="1767510040452"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3704"
          width="200"
          height="200"
        >
          <path
            d="M722.496 789.333333c-9.834667 36.992-44.202667 64-84.544 64H130.048C82.133333 853.333333 42.666667 815.274667 42.666667 767.573333l0.106666-3.136c0.256-3.242667 0.704-8.682667 1.408-15.573333 1.152-11.562667 2.56-23.104 4.224-34.048 3.413333-22.357333 7.317333-39.146667 13.376-51.797333C87.466667 609.365333 260.821333 538.24 384 538.24c59.136 0 129.856 16.384 190.229333 39.36C624.362667 552.618667 691.861333 533.333333 746.666667 533.333333c92.373333 0 220.842667 54.805333 241.429333 99.498667 4.864 10.56 7.786667 23.68 10.368 41.216a529.066667 529.066667 0 0 1 4.096 37.589333L1002.666667 714.666667a74.666667 74.666667 0 0 1-74.602667 74.666666h-205.568z m-47.36-159.573333c15.104 11.306667 25.984 22.613333 31.082667 33.258667 5.034667 10.517333 8.597333 23.893333 11.605333 40.981333h198.378667a424.96 424.96 0 0 0-2.176-17.578667c-0.853333-5.866667-1.813333-10.922667-2.517334-14.165333a112.426667 112.426667 0 0 0-7.808-5.461333 289.28 289.28 0 0 0-41.493333-21.397334C823.296 628.8 781.696 618.666667 746.666667 618.666667c-22.016 0-46.634667 4.010667-71.552 11.093333zM746.666667 490.666667a128 128 0 1 1 0-256 128 128 0 0 1 0 256z m0-85.333334a42.666667 42.666667 0 1 0 0-85.333333 42.666667 42.666667 0 0 0 0 85.333333z m-362.666667 80.426667A157.546667 157.546667 0 1 1 384 170.666667a157.546667 157.546667 0 0 1 0 315.093333z m0-85.333333A72.213333 72.213333 0 1 0 384 256a72.213333 72.213333 0 0 0 0 144.426667z m245.76 301.930666a142.08 142.08 0 0 0-16.021333-11.221333c-15.936-9.856-37.205333-20.48-60.736-30.144C496.426667 637.781333 435.84 623.573333 384 623.573333c-51.84 0-112.426667 14.186667-169.002667 37.397334-23.530667 9.642667-44.8 20.288-60.736 30.144a142.08 142.08 0 0 0-16.512 11.648c-1.365333 4.714667-3.285333 13.802667-4.992 24.896a590.997333 590.997333 0 0 0-4.629333 39.914666c0.256 0.106667 0.853333 0.405333 1.92 0.405334h507.904c1.066667 0 1.664-0.298667 1.92-0.405334a668.928 668.928 0 0 0-4.629333-39.914666c-1.706667-11.093333-3.626667-20.181333-4.992-24.896a55.594667 55.594667 0 0 0-0.490667-0.426667z"
            fill="#191d3a"
            p-id="3705"
          ></path>
        </svg>
      ),
    },
    {
      path: "/Home/emails",
      title: t ? t("sidebar.emails") : "Emails",
      icon: (
        <svg
          viewBox="0 0 24 24"
          width={24}
          height={24}
          stroke="currentColor"
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="_icon_8f5197c"
        >
          <path d="m21.5 18-6.643-6m-5.714 0L2.5 18M2 7l8.165 5.715c.661.463.992.695 1.351.784a2 2 0 0 0 .968 0c.36-.09.69-.32 1.351-.784L22 7M6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20Z" />
        </svg>
      ),
    },
    {
      path: "/Home/proxy",
      title: t ? t("sidebar.proxy") : "Proxy",
      icon: (
        <svg
          t="1767510206544"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="12128"
          width="200"
          height="200"
        >
          <path
            d="M499.9 26.4c99.2-0.1 179.8 80.2 179.9 179.5 0.1 82-55.5 153.7-135 174.2v53C699.5 450.5 830.6 555 881.7 702c73.4 12.7 122.4 82.7 109.6 156-11.2 64.3-66.9 111.2-132.1 111.6-74.4 0-134.8-60.2-134.9-134.6 0-48.3 25.7-92.8 67.5-116.8-41.7-104.3-135.8-178.5-247-194.6v184.2c70.2 24.8 107 101.9 82.2 172-24.9 70.2-101.9 106.9-172 82.1-70.2-24.8-107-101.8-82.1-172 13.5-38.3 43.7-68.5 82.1-82.1V523.6c-111.2 16.1-205.4 90.3-247.2 194.6 64.5 37.2 86.5 119.6 49.3 184-37.2 64.5-119.6 86.6-184.1 49.4s-86.5-119.7-49.3-184.1c20.1-34.8 54.6-58.8 94.3-65.5 51.2-147 182.2-251.6 336.9-269v-53c-96.1-25.1-153.6-123.4-128.5-219.4 20.7-78.9 91.9-133.9 173.5-134.2zM140.5 789.9c-24.8 0-44.9 20.2-44.9 45s20.1 44.9 44.9 44.9h0.1c24.8 0 44.9-20.1 44.9-44.9-0.1-24.8-20.2-45-45-45z m359.4 0c-24.8 0-44.9 20.2-44.9 45s20.1 44.9 44.9 44.9h0.1c24.8 0 44.9-20.1 44.9-44.9-0.2-24.8-20.2-45-45-45z m359.3 0c-24.8 0-44.9 20.2-44.9 45s20.1 44.9 44.9 44.9h0.1c24.8 0 44.9-20.1 44.9-44.9-0.1-24.8-20.2-45-45-45zM499.9 116.2c-49.6 0-89.8 40.2-89.8 89.9s40.2 89.8 89.8 89.8 89.8-40.2 89.8-89.8c-0.1-49.7-40.2-89.9-89.8-89.9z"
            p-id="12129"
            fill="#191d3a"
          ></path>
        </svg>
      ),
    },
    {
      path: "/Home/files",
      title: t ? t("sidebar.files") : "Files",
      icon: (
        <svg
          t="1767690693627"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="17656"
          width="200"
          height="200"
        >
          <path
            d="M365.719438 438.871438a182.857766 182.857766 0 1 1 0-365.715531 182.857766 182.857766 0 0 1 0 365.715531z m0-292.559624a109.701859 109.701859 0 1 0 0 219.403717 109.701859 109.701859 0 0 0 0-219.403717z m292.495621 0h292.623628v73.091903h-292.559625V146.311814z m0 146.24781h292.623628v73.155907h-292.559625V292.559624z m0 146.311814h182.921769V512.027345h-182.857766V438.871438z m0 512.027345H585.187159v-256.013672c0-60.611237-49.090622-109.765862-109.701859-109.765862H256.017579c-60.611237 0-109.765862 49.154625-109.765862 109.765862v256.013672H73.159813v-256.013672A182.857766 182.857766 0 0 1 256.017579 512.027345h219.403717a182.857766 182.857766 0 0 1 182.857766 182.857766v256.013672z"
            p-id="17657"
            fill="#191d3a"
          ></path>
        </svg>
      ),
    },

    {
      path: "/Home/whitelist",
      title: t ? t("sidebar.whitelist") : "Whitelist",
      icon: (
        <svg
          t="1749118495921"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="19288"
        >
          <path
            d="M512 64C264.96 64 64 264.96 64 512s200.96 448 448 448 448-200.96 448-448S759.04 64 512 64zM512 896C300.256 896 128 723.744 128 512 128 300.256 300.256 128 512 128c211.744 0 384 172.256 384 384C896 723.744 723.744 896 512 896zM641.088 512c17.696 0 32-14.336 32-32s-14.304-32-32-32L544 448l0-15.136 118.592-123.872c12.192-12.8 12-33.056-0.8-45.248-12.736-12.16-32.832-11.712-45.088 1.12l-101.6 106.784-107.584-107.36c-12.544-12.512-32.768-12.448-45.248 0.064-12.48 12.512-13.088 32.768-0.576 45.248L480 428.224 480 448l-94.784 0c-17.664 0-32 14.336-32 32s14.336 32 32 32L480 512l0 64-94.784 0c-17.664 0-32 14.304-32 32s14.336 32 32 32L480 640l0 95.136c0 17.696 14.336 32 32 32s32-14.304 32-32L544 640l97.088 0c17.696 0 32-14.304 32-32s-14.304-32-32-32L544 576l0-64L641.088 512z"
            fill="#191d3a"
            p-id="19289"
          ></path>
        </svg>
      ),
    },
  ];

  // determine visible items based on usertype cookie (2 = full access)
  const usertype = Number(Cookies.get("usertype"));
  const visibleNavItems =
    usertype === 2
      ? navItems
      : navItems.filter(
          (item) => item.path === "/Home/files" || item.path === "/Home/main"
        );

  return (
    <>
      <nav
        id="adminNav"
        className={`main-sidebar p-collapsing-sidebar sidebar-fixed sidebar-left d-flex flex-column ${
          isCollapsed ? "collapsed" : ""
        } ${mobileOpen ? "open mobile" : ""}`}
      >
        {mobileOpen && (
          <button
            className="sidebar-close-btn d-md-none"
            onClick={() => {
              if (typeof onMobileClose === "function") onMobileClose();
            }}
            aria-label="Close sidebar"
          >
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
              <path
                d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"
                fill="#374151"
              />
            </svg>
          </button>
        )}
        <div className={`logo-wrapper px-3 d-none d-md-flex`}>
          <img src="/head/emailLogo.png" alt="Logo" />
        </div>

        <div className="main-sidebar-inner" data-scrollbar="sidebar">
          <ul className="sidebar-nav sidebar-nav-light-hover list-unstyled text-unset small-3 fw-600 content-list">
            {visibleNavItems.map((item) => {
              const isActive =
                (currentPath === "/Home" && item.path === "/Home/orderList") ||
                currentPath === item.path;

              return (
                <li
                  key={item.path}
                  className={`nav-item text-light transition ${
                    isActive ? "active" : ""
                  }`}
                >
                  <Link
                    to={item.path}
                    onClick={() => {
                      if (mobileOpen && typeof onMobileClose === "function") {
                        onMobileClose();
                      }
                    }}
                    className={`sbr-collapse nav-link nav-link-border collapser collapser-active ${
                      isActive ? "sidebar-active" : ""
                    }`}
                    style={
                      isActive
                        ? {
                            background: "rgb(221 213 232)",
                            borderRadius: "16px",
                          }
                        : undefined
                    }
                  >
                    {item.icon}
                    <span className="p-collapsing-title">{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
      {/* overlay for mobile when sidebar open */}
      {mobileOpen && (
        <div className="sidebar-overlay" onClick={onMobileClose} />
      )}
    </>
  );
};

export default SiderBar;
